/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge, Flex, Popover, Tag,
} from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { TagsDisplay } from 'shared/types/Page.interface';
import cls from './TagsField.module.scss';

interface DeepObject {
  displayKey: string
  valuekey: string
}

interface TagsFieldProps {
  value: Array<any>
  deepObject?: DeepObject
  dateFormat?: boolean
  display?: TagsDisplay
}

export const TagsField: React.FC<TagsFieldProps> = React.memo((props) => {
  const {
    deepObject, value, dateFormat, display,
  } = props;
  const [sortedDates, setSortedDates] = useState<any[]>();
  const [closestPaymentDate, setClosestPaymentDate] = useState<any>();
  const badgeCount = (value && value.length - 1) || 0;

  useEffect(() => {
    if (!value || value.length === 0) {
      return;
    }
    if (dateFormat && deepObject) {
      const dates = [...value];
      dates.sort((a, b) => (dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1));
      setSortedDates(dates);
      const now = dayjs().format('YYYY-MM-DD');
      const futureDates = dates.filter((item) => dayjs(item.date).isAfter(now) || dayjs(item.date).isSame(now));
      let closestDate;
      if (futureDates.length === 0) {
        const pastDates = dates.filter((item) => dayjs(item.date).isBefore(now));
        closestDate = pastDates.reduce((closest, current) => (dayjs(current.date).diff(now) >= dayjs(closest.date).diff(now)
          ? current
          : closest));
      } else {
        closestDate = futureDates.reduce((closest, current) => (dayjs(current.date).diff(now) < dayjs(closest.date).diff(now)
          ? current
          : closest));
      }

      setClosestPaymentDate(closestDate);
    }
  }, []);

  return (
    <Flex gap={4}>
      {deepObject
        ? (
          <Popover
            content={sortedDates?.map((item, index) => (
              dateFormat
                ? (
                  <p
                    className={cls.tagItem}
                    key={index}
                    style={dayjs(item[deepObject.displayKey]).isSame(closestPaymentDate?.date) ? { backgroundColor: 'lightgray' } : {}}
                  >
                    {dayjs(item[deepObject.displayKey]).format('DD.MM.YYYY')}
                  </p>
                )
                : <p key={item}>{item[deepObject.displayKey]}</p>
            ))}
          >
            <Tag className={display === 'plain' && cls.plainTag}>
              <p>
                {dateFormat && closestPaymentDate
                  ? dayjs(closestPaymentDate?.date).format('DD.MM.YYYY')
                  : value[0]?.[deepObject.displayKey]}
              </p>
            </Tag>
            {badgeCount > 0 && <Badge count={`+${badgeCount}`} color="#9aaeff" style={{ marginLeft: 4 }} />}
          </Popover>
        )
        : (
          <Popover content={value?.map((item, index) => (dateFormat
            ? <p key={index}>{dayjs(item).format('DD.MM.YYYY')}</p>
            : <p key={index}>{item}</p>))}
          >
            <Tag className={display === 'plain' && cls.plainTag}>
              <p>{dateFormat && value?.[0] ? dayjs(value?.[0]).format('DD.MM.YYYY') : value?.[0]}</p>
            </Tag>
            {badgeCount > 0 && <Badge count={`+${badgeCount}`} color="#9aaeff" style={{ marginLeft: 4 }} />}
          </Popover>
        )}
    </Flex>
  );
});
